import React, { useEffect, useState } from 'react'
import './Questions.scss'
import Button, { ButtonsHolder } from '../../../partials/Button'
import Navigator from './Navigator/Navigator'
import Modal from '../../../partials/Modal/SimpleModal/SimpleModal'
import Question from '../../../partials/Questions/Question'
import Media from '../../../partials/Media'
import FeedbackBlock from "../../../partials/FeedbackBlock";
import HTMLContent from '../../../partials/HTMLContent';
import Scroll from '../../../partials/Scroll/Scroll'


const Questions = ({ data, next, onComplete }) => {

    const [showMissionParams, setShowMissionParams] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [completed, setCompleted] = useState(false);
    const [answersFeedback, setAnswersFeedback] = useState();
    const [showFeedback, setShowFeedback] = useState();

  
    useEffect(() => {
      if(currentIndex > -1 && currentIndex < data.questions.length) {
        setCurrentQuestion(data.questions[currentIndex])
      }
    }, [currentIndex])

    useEffect(()=>{

      if(next) {
        setAnswersFeedback()
        onContinueHandle()
      }
      
    }, [next])
    
    const handleNextQuestion = () => {
      setCompleted(false)
      onContinueHandle()
      setShowFeedback(false)
    }

    const handleRetryQuestion = () => {
        setCompleted(false)
        setCurrentQuestion({...currentQuestion, rand: Math.random()})
        setShowFeedback(false)
    }

    const handleAnswers = (feedback) => {
      setCompleted(true)
      setAnswersFeedback(feedback)
      setShowFeedback({
          status: feedback.status,
          caption: feedback.status === 'failed' && !feedback.correct ? 'Failed' : 
                   feedback.correct ? 'This Could Work' : 'It Might Work',
      })

    }
    
    const onContinueHandle = () => {
      
      if(currentIndex + 1 >= data.questions.length) {
        setCompleted(true)
        onComplete()
      } else {
        setCurrentIndex( currentIndex + 1 );
      }
    }


    const displayFeedback = (question) => {

      if(question.feedback){
        return <HTMLContent html={question.feedback[question.status]} />
      }
      else{
        
        const html = question.answers.map((answer, index)=>{

          return (
              <div key={index}>
                  <h3>{answer.option} </h3>
                  <p >
                      {answer.feedback}
                  </p>
                  
              </div>
          )
        })

        return <HTMLContent >{html}</HTMLContent>
      }

    }
    return (
        <div className="bus-questions">
          <>

              <div className="right-panel panel">
              {
                  <Scroll>
                    <div className={`question flex-content`} >
                      { currentQuestion &&
                          <Question 
                          data={currentQuestion}
                          feedback={handleAnswers}
                          showSubmit={!completed}
                          locked={!completed}
                        />
                      }
                    </div>
                  </Scroll>
              }
              </div>

              <div className="left-panel panel">

                <Media 
                   caption={'Story path decision'}
                   type={'image'}
                   src={ data.simulation.pathImage}
                   alt={ data?.simulation.pathImageAlt}
                   />
                <Navigator data={data.questions} index={currentIndex} onSelect={(index) => { setCurrentIndex(index) }} />

              </div>
          
          </>
          { showFeedback &&  
                <Modal 
                    size="small" 
                    show={showFeedback} 
                      >
                    <FeedbackBlock 
                        variant="fill"
                        status={showFeedback ? showFeedback.status : false }
                        caption={showFeedback ? showFeedback.caption : false } >
                            <Scroll>
                              <div className="scrollable-content">
                                { displayFeedback(answersFeedback) }
                              </div>
                            </Scroll>
                            <ButtonsHolder orientation="center">
                              { showFeedback.status ==="failed" &&
                                <Button text="Retry" onClick={ handleRetryQuestion } /> 
                              }
                              <Button text="Next" onClick={ handleNextQuestion } />
                            </ButtonsHolder> 
                    </FeedbackBlock>
                </Modal>
            }
          <Modal
              size='medium'
              show={showMissionParams}
              onClose={() => {
                  setShowMissionParams(false)
                }}
              >
            <div dangerouslySetInnerHTML={{ __html: data.missionParameters }}></div>
          </Modal>
        </div>
    )
}


export default Questions
